/* @flow */

import { createSelector } from 'reselect';
import _ from 'lodash';

// import { getUndoableState } from './undoable';
import { StepOrder } from '../utils/stepHelpers';

import type { StateType } from '../actions/design';

function getState(state: AppStateType): StateType {
  // return getUndoableState(state, 'design');
  return state.design;
}
// const getState: (state: AppStateType) => T = (state: AppStateType) => getUndoableState(state, 'design');

export const isLoading = (state: AppStateType): boolean => getState(state).loading;
const designData = (state: AppStateType): Object => getState(state);
const currentStep = (state: AppStateType): string => getState(state).currentStep;
const stepStatus = (state: AppStateType): Object => getState(state).stepStatus;
const initialValues = (state: AppStateType): Object => getState(state).initialValues;
const allValues = (state: AppStateType): Object => getState(state).values;
export const getSchematic = (state: AppStateType): Object => getState(state).schematic;

export function nextStep(step: string): string {
  const index = StepOrder.findIndex(i => i === step);
  if (index === StepOrder.length - 1) return StepOrder[index];
  return StepOrder[(index + 1) % StepOrder.length];
}

export function prevStep(step: string): string {
  const index = StepOrder.findIndex(i => i === step);
  if (index === 0) return StepOrder[index];
  // index = index === 0 ? StepOrder.length : index;
  return StepOrder[(index - 1) % StepOrder.length];
}

export const getCurrentStep = createSelector(
  [currentStep],
  (step: string) => step,
);

export const getNextStep = createSelector(
  [currentStep],
  (step: string) => nextStep(step),
);

export const getPrevStep = createSelector(
  [currentStep],
  (step: string) => prevStep(step),
);

export const getAllData = createSelector(
  [designData, isLoading],
  data => data,
);

export const getFieldValues = createSelector(
  [getAllData],
  data => data.values,
);

export const getChangedFields = createSelector(
  [getAllData],
  data => data.changedFields,
);

export const getFieldErrors = createSelector(
  [getAllData],
  data => data.errors,
);

export const getDirtyFields = createSelector(
  [getAllData],
  data => data.dirtyFields,
);

export const getValuesForEval = createSelector(
  [getFieldValues, getChangedFields],
  (values, changedValues) => _.pick(values, Object.keys(changedValues)),
);

export const getDesignName = createSelector(
  [designData],
  data => data.name,
);

export const getStepStatus = createSelector(
  [stepStatus],
  data => data,
);

export const getSnubberStatus = createSelector(
  [allValues],
  (values): string | number => _.get(values, ['Snub_sel', 'currentValue']),
);

export const getResetStatus = createSelector(
  [getCurrentStep, allValues, initialValues, isLoading],
  (step, vals, initialVals) => !_.isEqual(vals, initialVals),
);



// WEBPACK FOOTER //
// ./src/selectors/design.js